<div class="work-order-timeline">
  <header class="timeline-header">
<img src="assets/images/naologic.png" alt="NAOLOGIC" class="logo" />
    <h1 class="title">Work Orders</h1>
  </header>

  <div class="timescale-controls" [class.open]="isTimescaleOpen" (click)="$event.stopPropagation()">
    <div class="timescale-pill">
      <span class="timescale-static">Timescale</span>
      <button
        type="button"
        class="timescale-trigger"
        (click)="toggleTimescaleMenu($event)"
        [attr.aria-expanded]="isTimescaleOpen"
        aria-haspopup="listbox"
        aria-label="Select timescale"
      >
        <span>{{ getTimescaleLabel(timescaleMode) }}</span>
        <span class="timescale-chevron" aria-hidden="true"></span>
      </button>
    </div>

    <div class="timescale-menu" *ngIf="isTimescaleOpen" role="listbox" aria-label="Timescale options">
      <button
        type="button"
        class="timescale-option"
        *ngFor="let option of timescaleOptions"
        [class.active]="option.value === timescaleMode"
        (click)="selectTimescale(option.value, $event)"
      >
        {{ option.label }}
      </button>
    </div>
  </div>

  <div class="timeline-container">
    <aside class="work-centers-sidebar">
      <div class="sidebar-header">Work Center</div>
      <div
        class="work-center-row"
        *ngFor="let center of workCenters; trackBy: trackById"
        [style.height.px]="getRowHeight(center.docId)"
      >
        <span class="center-name">{{ center.data.name }}</span>
      </div>
    </aside>

    <section class="timeline-grid-wrapper" #timelineScroller>
      <div class="timeline-scroll" [style.width.px]="totalTimelineWidthPx">
        <div class="timeline-header-row" [attr.data-mode]="timescaleMode">
          <div
            class="time-segment"
            [class.current-segment]="segment.isCurrent"
            *ngFor="let segment of headerSegments"
            [style.width.px]="segment.width"
          >
            {{ segment.label }}
            <span class="current-month-tag" *ngIf="segment.isCurrent">Current month</span>
          </div>
        </div>

        <div class="timeline-grid" #timelineGrid>
          <div class="current-day-indicator" [style.left.px]="currentDayOffsetPx"></div>

          <div class="day-columns">
            <div class="day-column" *ngFor="let day of timelineDays"></div>
          </div>

          <div class="month-separators">
            <div 
              class="month-separator" 
              *ngFor="let separator of monthSeparators"
              [style.left.px]="separator.left"
            ></div>
          </div>

          <div class="work-order-rows">
            <div
              class="work-order-row"
              *ngFor="let center of workCenters; trackBy: trackById"
              [style.height.px]="getRowHeight(center.docId)"
              (click)="onTimelineClick(center.docId, $event)"
            >
              <div
                class="work-order-bar"
                *ngFor="let layout of getVisualWorkOrdersForCenter(center.docId); trackBy: trackByLayout"
                [style.left.px]="layout.leftPx"
                [style.width.px]="layout.widthPx"
                [style.top.px]="getBarTopPx(layout.lane)"
                [ngClass]="getStatusClass(layout.order.data.status)"
                (click)="$event.stopPropagation()"
                [title]="layout.order.data.name"
              >
                <div class="bar-content">
                  <span class="order-name">{{ layout.order.data.name }}</span>
                  <span
                    class="status-badge"
                    [ngClass]="getStatusClass(layout.order.data.status)"
                    *ngIf="showStatusBadge(layout.widthPx)"
                  >
                    {{ getStatusLabel(layout.order.data.status) }}
                  </span>
                </div>

                <div class="three-dot-menu">
                  <button class="menu-trigger" (click)="toggleOrderMenu(layout.order.docId, $event)" aria-label="Actions">
                    <span class="dot"></span>
                    <span class="dot"></span>
                    <span class="dot"></span>
                  </button>
                  <div class="menu-dropdown" *ngIf="isMenuOpen(layout.order.docId)">
                    <button type="button" (click)="openEditPanel(layout.order, $event)">Edit</button>
                    <button type="button" class="delete-btn" (click)="deleteWorkOrder(layout.order, $event)">Delete</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</div>

<div class="panel-overlay" *ngIf="isPanelOpen" (click)="closePanel()"></div>

<aside class="slide-panel" [class.open]="isPanelOpen" #slidePanel tabindex="0">
  <div class="panel-header">
    <div class="panel-title-wrap">
      <h2>Work Order Details</h2>
      <p>Specify the dates, name and status for this order</p>
    </div>
    <div class="panel-top-actions">
      <button type="button" class="action-btn action-btn-secondary" (click)="closePanel()">Cancel</button>
      <button type="button" class="action-btn action-btn-primary" (click)="onSubmit()">
        {{ panelMode === 'create' ? 'Create' : 'Save' }}
      </button>
    </div>
  </div>

  <form [formGroup]="workOrderForm" (ngSubmit)="onSubmit()" class="panel-form">
    <div class="form-group">
      <label for="order-name">Work Order Name</label>
      <input id="order-name" type="text" class="form-control" formControlName="name" />
      <div class="error-message" *ngIf="workOrderForm.controls.name.touched && workOrderForm.controls.name.invalid">
        Work order name is required.
      </div>
    </div>

    <div class="form-group">
      <label for="order-status-input">Status</label>
      <ng-select
        id="order-status"
        labelForId="order-status-input"
        name="status"
        [ngClass]="{
          'status-select-open': workOrderForm.controls.status.value === 'open',
          'status-select-in-progress': workOrderForm.controls.status.value === 'in-progress',
          'status-select-complete': workOrderForm.controls.status.value === 'complete',
          'status-select-blocked': workOrderForm.controls.status.value === 'blocked'
        }"
        [inputAttrs]="{ name: 'order-status' }"
        formControlName="status"
        [items]="statusOptions"
        bindLabel="label"
        bindValue="value"
        [clearable]="false"
        [searchable]="false"
      ></ng-select>
    </div>

    <div class="form-group">
      <label for="end-date">End date</label>
      <div class="date-input-wrap">
        <input
          id="end-date"
          class="form-control date-field date-picker-input"
          type="text"
          formControlName="endDate"
          ngbDatepicker
          #endDatePicker="ngbDatepicker"
          placement="top-start bottom-start"
          container="body"
          autoClose="true"
          (click)="openDatePicker(endDatePicker, $event)"
          (dateSelect)="closeDatePicker(endDatePicker)"
        />
      </div>
      <div
        class="error-message"
        *ngIf="workOrderForm.controls.endDate.touched && workOrderForm.controls.endDate.invalid"
      >
        End date is required.
      </div>
    </div>

    <div class="form-group">
      <label for="start-date">Start date</label>
      <div class="date-input-wrap">
        <input
          id="start-date"
          class="form-control date-field date-picker-input"
          type="text"
          formControlName="startDate"
          ngbDatepicker
          #startDatePicker="ngbDatepicker"
          placement="bottom-start top-start"
          container="body"
          autoClose="true"
          (click)="openDatePicker(startDatePicker, $event)"
          (dateSelect)="closeDatePicker(startDatePicker)"
        />
      </div>
      <div class="error-message" *ngIf="workOrderForm.controls.startDate.touched && workOrderForm.controls.startDate.invalid">
        Start date is required.
      </div>
    </div>

    <div class="error-message overlap-error" *ngIf="overlapError">{{ overlapError }}</div>
  </form>
</aside>
